export default __webpack_public_path__ + "static/media/neon.5ce6ef5a.png";